// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"c9717c6c","26":"7f2b970b"}[chunkId] + ".chunk.css";
};